import { AppLink } from "@/components/ui/app-link";
import { cn } from "@/lib/utils";
import { useTranslation } from "react-i18next";

const TONE: Record<number, string> = {
  0: "border-red-500/40 text-red-700 dark:text-red-300",
  1: "border-amber-500/40 text-amber-800 dark:text-amber-200",
  2: "border-sky-500/40 text-sky-800 dark:text-sky-200",
  3: "border-emerald-500/40 text-emerald-800 dark:text-emerald-200",
};

/** The autonomy level as a small badge; the title explains what it leaves to a person. */
export function AutonomyBadge({
  level,
  href,
  label,
  className,
}: {
  level: number;
  href?: string | undefined;
  /** Overrides the default "Autonomy N" text. */
  label?: string;
  className?: string;
}) {
  const { t } = useTranslation();
  const text = label ?? t("autonomy.label", { level });
  const title = `${t(`autonomy.levels.${level}.name`)}: ${t(`autonomy.levels.${level}.text`)}`;
  const classes = cn(
    "inline-flex items-center rounded-full border px-2 py-0.5 align-middle text-[11px] font-medium",
    TONE[level] ?? TONE[2],
    className,
  );
  return href ? (
    <AppLink
      href={href}
      title={title}
      data-testid="autonomy-badge"
      className={cn(classes, "hover:underline")}
    >
      {text}
    </AppLink>
  ) : (
    <span title={title} data-testid="autonomy-badge" className={classes}>
      {text}
    </span>
  );
}
